import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../../Common/DataTable';
// import ComponentDeleteModal from '../../../Common/DeleteModal/ComponentDeleteModal';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import { REQUEST } from '../utils/constants';
import {
  getApprovedEquipmentRequestDataStart, setEquipmentRequestTab,
} from '../TestEquipmentRequestScreen/redux/equipmentRequestSlice';
import { setLoader } from '../../../redux/loaderSlice';
import { RootState } from '../../../redux/rootState';
import { defaultPageSize } from '../../../utils/Constant';
import { EquipmentRequestListingFields } from '../TestEquipmentRequestScreen/redux/type';
import { EquipmentRequestListData } from '../utils/types';
import { getRoleById } from '../../../Routes/constant';
import { getEasternTime } from '../../../utils/CommonFunctions';

export default function ApprovedEquipmentRequests() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const { isLoading, approvedEquipmentRequestData } = useSelector((state: RootState) => state.inventoryEquipmentRequestReducer);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleData = () => {
    const payload = {
      page,
      searchQuery,
      rowsPerPage,
      sortCol,
      sortDir,
    };
    dispatch(getApprovedEquipmentRequestDataStart(payload));
  };

  const handleEdit = (id: string) => {
    dispatch(setEquipmentRequestTab(REQUEST));
    const record = approvedEquipmentRequestData?.Data?.find((element) => element?.RequestId === id);
    // navigate(`${EndPoints.TEST_EQUIPMENT_REQUEST_FORM}/${id}/${record?.RoleId}`);
    navigate(`/test-request/${record?.UnitId}/${id}/2/${record?.IsNewJob ? 'new' : 'reg'}`);
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: approvedEquipmentRequestData?.Data?.length > 0 ? approvedEquipmentRequestData?.Data : [],
      },
      'APPROVED EQUIPMENT REQUESTS',
    );
  };

  const ApprovedEquipmentRequestTableColumns = [
    { key: 'action', label: 'Action' },
    { key: 'requestId', label: 'Request Id' },
    { key: 'unitId', label: 'Job Order #' },
    { key: 'vessel', label: 'Vessel' },
    { key: 'requestedBy', label: 'Requested By' },
    { key: 'roleId', label: 'Requester Role' },
    { key: 'dateValue', label: 'Submitted At (EST)' },
    { key: 'status', label: 'Status' },
  ];

  function formatApprovedEquipmentRequestListData(data: EquipmentRequestListingFields[]) {
    const res: EquipmentRequestListData[] = [];

    if (data?.length === 0) return [];

    data?.forEach((col: EquipmentRequestListingFields, index) => {
      const obj = {
        sn: index,
        unitId: '',
        vessel: '',
        requestedBy: '',
        roleId: '',
        action: 'eye',
        id: '',
        requestId: '',
        status: '',
        dateValue: '',
      };
      obj.id = col.RequestId;
      obj.requestId = col.RequestId;
      obj.unitId = col.UnitId;
      obj.vessel = col.Vessel;
      obj.requestedBy = col.RequestedBy;
      obj.status = col.Status;
      obj.dateValue = getEasternTime(col.DateValue);
      obj.roleId = getRoleById(String(col.RoleId));
      res.push(obj);
    });

    return res;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading="APPROVED EQUIPMENT REQUESTS" downloadExcel={downloadExcel} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
          <DataTable
            data={approvedEquipmentRequestData?.Data?.length > 0 ? formatApprovedEquipmentRequestListData(approvedEquipmentRequestData?.Data) : []}
            columns={ApprovedEquipmentRequestTableColumns}
            totalRecords={approvedEquipmentRequestData?.TotalRecords}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPage(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPage(1); }}
            handleData={handleData}
            // handleDelete={handleDelete}
            // buttonText="Add"
            // handleButtonClick={() => navigate(EndPoints.TEST_EQUIPMENT_REQUEST_FORM)}
            handleViews={handleEdit}
            handleDataFromComponent
          />
        </Grid>
      </Grid>
      {/* <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setDeleteModal(false)}
        handleDelete={handleDeleteModal}
      /> */}

    </>
  );
}
